export const isAuthenticated = () => {
    return !!(localStorage.getItem('token') || sessionStorage.getItem('token'));
};
